import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--circuit", {
  segmentWidth: units.px(10),
  offset: 0,
  pointX: 0,
  pointY: 0
});
const wrapper = "_35swze51gz";
const container = "_35sc1lufpap";
const circuit = "_35sc1m592sj";
const item = "_35sihx0v5";
function getPointOnCircle(t) {
  const deg = t * 360 - 90;
  const rad = deg * (Math.PI / 180);
  return {
    x: 0.5 + 0.5 * Math.cos(rad),
    y: 0.5 + 0.5 * Math.sin(rad)
  };
}

export { circuit, container, getPointOnCircle, item, tokens, wrapper };
import "./container.input.style.linaria.module.css";
//# sourceMappingURL=container.input.style.js.map
